import React, { useState, useContext, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import CashierApi from "../../utility/CashierApi";

import { CustomerContext } from "../CashierHomepage";
import { CustomerIdContext } from "../../context/CustomerIdProvider";
import { AutoBillContext } from "../../context/AutoBillProvider";

import DeleteCartItem from "./DeleteCartItem";
import CartItemQuantity from "./CartItemQuantity";
import CartAutobill from "./CartAutobill";

function CartItem({ setTotalSum, currency }) {
  const [total, setTotal] = useState(0);
  const { fetchOnlyData } = CashierApi();
  const navigate = useNavigate();

  const { autoBill, setAutoBill } = useContext(AutoBillContext);
  const { selectedCustomerId } = useContext(CustomerIdContext);
  const { setNewCartData } = useContext(CustomerContext);

  // Fetch cart data
  const { data } = useQuery({
    queryKey: ["cart", selectedCustomerId],
    queryFn: () => fetchOnlyData(`carts/${selectedCustomerId}`),
    enabled: !!selectedCustomerId,
  });

  // Calculate total price from cart items
  useEffect(() => {
    if (data?.length === 0) {
      setTotalSum(0);
      return;
    } else {
      const totalAmount = data?.reduce(
        (sum, item) => sum + Number(item?.total_price),
        0
      );
      setTotal(totalAmount);
      setNewCartData(data);
    }
  }, [data]);

  // Calculate total including auto billing
  useEffect(() => {
    if (!autoBill || !Array.isArray(autoBill) || data?.length === 0) {
      setTotalSum(0);
    } else {
      const totalBillAmount = autoBill?.reduce(
        (sum, bill) => sum + Number(bill?.auto_bill || 0),
        0
      );

      setTotalSum(Number(totalBillAmount) + Number(total));
    }

    // console.log("checking", total, autoBill, data);
  }, [total, autoBill, data]);

  // Handle unauthorized access
  if (
    typeof data === "object" &&
    (data?.status === 401 || data?.response?.status === 401)
  ) {
    navigate("/login");
  }

  return (
    <tbody>
      {data?.map((item, index) => (
        <tr
          key={item.id}
          className="hover:bg-gray-950 border-b border-gray-300 h-4"
        >
          <td className="py-2 px-1 text-center">{index + 1}</td>
          <td className="py-2 px-2 text-center">
            {item?.product?.product_name}
          </td>
          <td className="py-2 px-2 text-center">
            {currency}
            {item?.price}
          </td>
          <td>
            <CartItemQuantity item={item} />
          </td>
          <td>
            <DeleteCartItem itemId={item.id} data={data} />
          </td>
        </tr>
      ))}
      {data?.length > 0 && (
        <CartAutobill
          currency={currency}
          total={total}
          autoBill={autoBill}
          setAutoBill={setAutoBill}
        />
      )}
    </tbody>
  );
}

export default React.memo(CartItem);
